import type { Meta, StoryObj } from "@storybook/react";

import type { NotificationSettingsCardProps } from "@/ui/components/notificationSettings";
import { NotificationSettingsCard } from "@/ui/components/notificationSettings";
import { ActionBar, Button, FAIconName } from "@/ui/core";
import { Box, VStack } from "@/ui/layout";

const StoryMeta: Meta<NotificationSettingsCardProps> = {
  title: "Components/Profile/Edit Notification Settings Card",
  component: NotificationSettingsCard,
  argTypes: {
    children: {
      mapping: {
        WithWarningMessage: (
          <VStack gap={12}>
            <ActionBar
              iconName={FAIconName.InfoCircle}
              message="You've allowed us to send push notifications, but this device is not currently set up to receive them."
              size="small"
              testID="push-disabled-message"
              variant="critical"
            />
            <Button
              leftIcon={FAIconName.Gear}
              onPress={() => {
                console.log("manage app permissions");
              }}
              testID="push-disabled-cta"
              title="Manage app permissions"
              variant="secondary"
            />
          </VStack>
        ),
      },
    },
    isChecked: { control: "boolean" },
    isDisabled: { control: "boolean" },
    isRecommended: { control: "boolean" },
    message: { control: "text" },
    title: { control: "text" },
  },
  args: {
    isChecked: true,
    isDisabled: false,
    isRecommended: true,
    message: "Enable Email notifications here",
    title: "Email",
  },
  render: (props) => (
    <Box width="100%">
      <NotificationSettingsCard {...props} />
    </Box>
  ),
};

type Story = StoryObj<NotificationSettingsCardProps>;

const Primary: Story = {};

const WithWarningMessage: Story = {
  args: {
    children: "WithWarningMessage",
    message:
      "Notifications may include alerts, sounds, and icon badges. These can be configured in your iOS Settings for the Equip Health app.",
    title: "Push notifications",
  },
};

export { Primary, WithWarningMessage };
export default StoryMeta;
